<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row v-if="!isAdmission">
      <v-col cols="12" lg="4" sm="6"
        v-if="(formType !== 'edit_registration' && formType !== 'registration')">
        <span class="body-2 font-weight-medium">Next Followup Date</span>
        <custom-date-picker :minToDate="maxToDate" v-model="value.followUpDate" />
      </v-col>

      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Point Of Contact</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete @change="viewdata" v-model="value.pointOfContact" required class="my-0 py-1"
          single-line label="---Select---" :items="pointOfContact" item-text="pointOfContact"
          item-value="pointOfContact">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="4" sm="6"
        v-if="showdata ? showdata : this.value.pointOfContact === 'OTHER'">
        <span class="body-2 font-weight-medium"> Relationship <span class="error--text ml-1" v-if="this.value.pointOfContact === 'OTHER'">*</span></span>
        <v-text-field :required="isRequired" v-model="value.relationWithApplicant" class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6"
        v-if="showdata ? showdata : this.value.pointOfContact === 'OTHER'">
        <span class="body-2 font-weight-medium"> Guardian Name <span class="error--text ml-1" v-if="this.value.pointOfContact === 'OTHER'">*</span></span>
        <v-text-field v-model="value.guardianName" :required="isRequired" class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6"
        v-if="showdata ? showdata : this.value.pointOfContact === 'OTHER'">
        <span class="body-2 font-weight-medium"> Guardian Mobile No. <span class="error--text ml-1" v-if="this.value.pointOfContact === 'OTHER'">*</span></span>
        <v-text-field type="number" class="my-0 py-1" :required="isRequired" onKeyPress="if(this.value.length==10) return false;"
          v-model="value.guardianMobile"></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6"
        v-if="showdata ? showdata : this.value.pointOfContact === 'OTHER'">
        <span class="body-2 font-weight-medium"> Guardian Email ID <span class="error--text ml-1" v-if="this.value.pointOfContact === 'OTHER'">*</span></span>
        <v-text-field type="email" class="my-0 py-1" :required="isRequired" v-model="value.guardianEmailID"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6"
        v-if="(formType === 'edit_registration' || formType==='registration' || formType ==='admission')">
        <span class="body-2 font-weight-medium"> Persons who can be contacted in case of
          emergency </span>
        <v-text-field class="my-0 py-1" v-model="value.emergencyContactDetails"
          placeholder="Name, Relation, Occupation, Address, Mobile"></v-text-field>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'OtherElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    formMode: {
      default: '',
      type: String
    }
  },
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data: function () {
    return {
      cardTitle: '',
      cardIcon: '',
      isAdmission: false,
      stages: [],
      showdata: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      pointOfContact: ['FATHER', 'MOTHER', 'GAURDIAN', 'OTHER'],
      sourceStages: [],
      enquiryStageData: [],
      isRequired: false,
      obj: {
        followUpDate: new Date(),
        queryInterestTypeID: '',
        sourceID: '',
        pointOfContact: '',
        guardianName: '',
        guardianMobile: '',
        guardianEmailID: ''
      }
    }
  },

  async created () {
    await this.customCreate()
  },
  methods: {
    customCreate: async function () {
      if (this.stuData) {
        this.obj = {
          queryInterestTypeID: this.stuData.queryInterestTypeID,
          sourceID: this.stuData.sourceID,
          pointOfContact: this.stuData.pointOfContact,
          guardianName: this.stuData.guardianName,
          guardianMobile: this.stuData.guardianMobile,
          guardianEmailID: this.stuData.guardianEmailID
        }
      }
      this.isWrite = Utils.helper.getIsWriteFun(this.$route)

      try {
        const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
        this.stages = questions.filter((obj) => obj.type === 'INTEREST_TYPE')
        const { data: questions1 } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
        this.sourceStages = questions1.filter((obj) => obj.type === 'SOURCE_OF_CONTACT')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
      if (this.formType !== 'admission' && this.formType !== 'createAdmission') {
        this.cardTitle = 'Other Details'
        this.cardIcon = 'mdi-account-details'
      } else {
        this.isAdmission = true
      }
    },
    viewdata () {
      this.showdata = this.value.pointOfContact === 'OTHER'
      if (this.value.pointOfContact === 'OTHER') {
        this.isRequired = true
      } else if (this.value.pointOfContact === 'GAURDIAN') {
        this.showdata = this.value.pointOfContact === 'GAURDIAN'
      }
    }
  }
}
</script>
